module.exports = __webpack_public_path__ + "media/images/brand/logo/tfs_logo-4bd0eda44f5e2d81ae90ad2949f88ed4.png";